import { CourseStatus } from '@cna/projects/ak-jura/shared/interfaces';
import { createReducer, on } from '@ngrx/store';
import { from } from 'rxjs';
import { migrateCourseFailure } from './actions';
import * as fromActions from './actions';

export const COURSE_STORE_NAME = 'course';

export interface CourseState {
    loading: boolean;
    course: any;
    status?: CourseStatus;
    migrationInProgress: boolean;
}

const initialState = {
    loading: false,
    course: undefined,
    status: undefined,
    migrationInProgress: false,
};

const _courseReducer = createReducer<CourseState>(
    initialState,

    on(fromActions.setCourseParticipation, state => ({
        ...state,
        loading: true,
    })),

    on(fromActions.setCourseParticipationSuccess, state => ({
        ...state,
        loading: false,
    })),

    on(fromActions.checkCourseStatusSuccess, (state, { status }) => ({
        ...state,
        status,
    })),

    on(fromActions.migrateCourse, state => ({
        ...state,
        migrationInProgress: true,
    })),
    on(fromActions.migrateCourseSuccess, migrateCourseFailure, state => ({
        ...state,
        migrationInProgress: false,
    }))
);

export function courseReducer(state, action) {
    return _courseReducer(state, action);
}
